export default __webpack_public_path__ + "static/media/select-radio-active.c972654e.svg";